import React from "react";
import { Menu, Transition } from "@headlessui/react";
import clsx from "clsx";
import Link from "next/link";
import { FaCaretDown } from "react-icons/fa";

const DropdownContainer = ({ children, label }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full justify-center items-center rounded-md px-2 py-1 text-sm font-medium text-gray-500 hover:bg-opacity-30 focus:outline-none ring-2 ring-gray-200 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
          {label}
        </Menu.Button>
      </div>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          static
          className="absolute z-10 right-0 mt-1 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

const DisplayIcon = ({ Icon, isActive }) => {
  return (
    <Icon
      fontSize={12}
      aria-hidden="true"
      className={clsx("mr-2 h-5 w-5", {
        "text-gray-400": isActive,
        "text-brand-primary": !isActive,
      })}
    />
  );
};

const DropdownItem = ({
  onClick,
  text,
  Icon,
  href = null,
  isInternal = false,
}) => {
  // Es un link
  if (href) {
    if (isInternal) {
      return (
        <Menu.Item>
          {({ active }) => (
            <Link href={href}>
              <a rel="noopener noreferrer">
                <button
                  className={`${
                    active ? "bg-brand-primary text-white" : "text-gray-900"
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                >
                  {Icon && <DisplayIcon Icon={Icon} isActive={active} />}
                  {text}
                </button>
              </a>
            </Link>
          )}
        </Menu.Item>
      );
    }
    return (
      <Menu.Item>
        {({ active }) => (
          <a target="_blank" href={href} rel="noopener noreferrer">
            <button
              className={`${
                active ? "bg-brand-primary text-white" : "text-gray-900"
              } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
            >
              {Icon && <DisplayIcon Icon={Icon} isActive={active} />}
              {text}
            </button>
          </a>
        )}
      </Menu.Item>
    );
  }
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          type="#"
          className={`${
            active ? "bg-brand-primary text-white" : "text-gray-900"
          } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
          onClick={onClick}
        >
          {Icon && <DisplayIcon Icon={Icon} isActive={active} />}
          {text}
        </button>
      )}
    </Menu.Item>
  );
};

const DropdownWithButton = ({ button, children }) => {
  return (
    <div className="inline-flex items-stretch rounded-md border bg-white">
      {button}
      <Menu as="div" className="relative">
        <div className="inline-flex h-full w-full items-center justify-center rounded-r-md border-l border-gray-100  text-gray-600 hover:bg-gray-50 hover:text-gray-700">
          <Menu.Button className="h-full w-full px-1 md:px-2">
            <span className="sr-only">Menu</span>
            <FaCaretDown fontSize={12} />
          </Menu.Button>
        </div>
        <Transition
          as={React.Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            static
            className="absolute z-10 right-0 mt-1 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            {children}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

const Dropdown = {
  Container: DropdownContainer,
  Item: DropdownItem,
  WithButton: DropdownWithButton,
};

export default Dropdown;
